// Set reset container script
Jelly.Interface.Add_Refresh_Container_Listener = function(Script){
	Jelly.Interface.Refresh_Container_Listeners.push(Script);
};

Jelly.Interface.Add_Refresh_Listener = function(Script) {
	Jelly.Interface.Refresh_Listeners.push(Script);
};